import React from "react";
import FormikRadioField from "./FormikRadioField";

export default function YesNoRadioField({ yesLabel = "Yes", noLabel = "No", ...props }) {
  return (
    <FormikRadioField
      {...props}
      options={[
        { label: yesLabel, value: true },
        { label: noLabel, value: false },
      ]}
    />
  );
}
